module.exports = __webpack_public_path__ + "img/icon_1_40.f65cada3.png";